import { Box } from '@inflearn/ds-react-next';
import { backgroundStyle, decorationStyle } from './styles';
import type { RedLightGameBackgroundProps } from './types';

export const RedLightGameBackground = ({
  backgroundUrl,
  decorations,
}: RedLightGameBackgroundProps) => {
  return (
    <>
      <Box
        css={backgroundStyle}
        style={{
          backgroundImage: `url(${backgroundUrl})`,
        }}
      />
      {decorations.map((decoration) => (
        <Box
          key={decoration.id}
          css={decorationStyle(decoration.x, decoration.y, decoration.size)}
          style={{
            backgroundImage: `url(${decoration.imageUrl})`,
          }}
        />
      ))}
    </>
  );
};
